import useVerifyMobile from "./useVerfiyMobile";
import {Button as AtButton, Col, Form, Input, Modal, ModalProps, Result, Row, Space, Spin, Typography} from "antd";
import {ActivateLayout, Highlight, VerifyResult} from "./styles";
import React, {useEffect, useMemo, useState} from "react";
import useFormInstance from "antd/es/form/hooks/useFormInstance";
import {useForm} from "antd/es/form/Form";
import {useMutation, useQueryClient} from "react-query";
import {http, isErrorException} from "@firefly/fly-http";
// import omitUndefined from "../../../util/omitUndefined";
import format from "../../../util/format";
import Activation from "./index";
import {omitUndefined} from "@firefly/fly-defter";

export interface VerifyModalProps extends Pick<ModalProps, 'open' | 'destroyOnClose'>{
    gameId: string;
    verified: boolean;
    onCancel: () => void;
    onFinish: () => void;

}

interface VerifyMobileProps {
    gameId?: string;
    onFinish: () => void;
}
function VerifyMobile(props: VerifyMobileProps) {
    const {
        gameId,
        onFinish,
    } = props;
    const {
        sendLabel,
        sendLoading,
        sendDisabled,
        send,
    } = useVerifyMobile(gameId);
    const {
        mutateAsync: verify,
        isLoading: verifyLoading,
        error,
        reset,
    } = useMutation({
        mutationFn: ({mobile, code}: {mobile: string, code: string}) => {
            return http.post(`/api/wangame/viewer/game-vip/verify-mobile/verify`, omitUndefined({
                "mobile": mobile,
                "code": code,
                "gameId": gameId,
            })).then((result: boolean) => {
                return result
            })
        }
    })

    const [form] = useForm();
    function finish() {
        form.validateFields().then((value) => {
            return verify({
                mobile: value.mobile,
                code: value.code,
            }).then((pass) => {
                console.log("verify:", pass)
                if (pass) {
                    onFinish();
                }
            })
        })
    }
    const verifyErrorMessage = useMemo(() => {
        return error ? format(error) : undefined;
    }, [error])
    return <>
        <Typography.Text style={{display: "block", marginBottom: 30, marginTop: 30}}>
            您的账号尚未绑定手机号，成功绑定可激活<Highlight>100%自动返利</Highlight>白名单
        </Typography.Text>
        <Form form={form} labelCol={{
            span: 6
        }}>
            <Form.Item label={"手机号"} >
                <Space>
                    <Form.Item name={"mobile"} noStyle
                               rules={[
                                   {required: true, message: '请输入您的手机号码', max: 11},
                                   ({getFieldValue}) => ({
                                       validator(_, e: any) {
                                           const value = getFieldValue('mobile');
                                           if(value){
                                               if (!(/^(1[3456789]|9[28])\d{9}$/).test(value)) {
                                                   return Promise.reject(new Error('请输入11位有效手机号码！'));
                                               }
                                               return Promise.resolve();
                                           }
                                           return Promise.resolve();
                                       },
                                   })
                               ]}
                    >
                        <Input style={{width: 210}} placeholder={"请输入您的手机号码"} />
                    </Form.Item>
                    <Form.Item
                        noStyle dependencies={["mobile"]}
                    >
                        {({getFieldValue}) => {
                            return <AtButton type={"primary"} ghost loading={sendLoading} disabled={sendDisabled} onClick={() => {
                                return send({
                                    mobile: getFieldValue("mobile")
                                });
                            }}>
                                {sendLabel}
                            </AtButton>
                        }}
                    </Form.Item>

                </Space>
            </Form.Item>
            <Form.Item label={"验证码"} name={"code"}
                       hasFeedback={!!verifyErrorMessage}
                       validateStatus={verifyErrorMessage ? 'error' : undefined}
                       help={verifyErrorMessage?.title}
                       rules={[
                           {required: true, message: "请输入验证码"}
                       ]}
            >
                <Input placeholder={"请输入6位数验证码"} style={{width: 210}}  />
            </Form.Item>
        </Form>
        <Row justify={"center"} style={{paddingTop: 30}}>
            <Col>
                <AtButton size={"large"} style={{
                    width: 200
                }} type={"primary"}
                          onClick={finish}
                >绑定</AtButton>
            </Col>
        </Row>
    </>
}
export interface VerifiedActivateProps {
    gameId: string;
    activated?: boolean;
    onCancel: () => void;
}
function VerifiedActivate(props: VerifiedActivateProps) {
    const {
        gameId,
        activated,
        onCancel
    } = props;

    const [isActivated, setIsActivated] = useState<boolean>(activated??false);
    const queryClient = useQueryClient();
    function onActivated() {
        setIsActivated(true);
        queryClient.invalidateQueries({
            queryKey: ['viewer']
        }).then();
    }
    const {
        mutateAsync: activate,
        isLoading: activateLoading
    } = useMutation({
        mutationFn: () => {
            return http.post(`/api/wangame/viewer/game-vip/verify-mobile/activate`, omitUndefined({
                "gameId": gameId,
            })).then((result) => {
                onActivated()
            }).catch((error) => {
                if (isErrorException(error)) {
                    const {
                        error: errorInfo
                    } = error;
                    if (errorInfo.code === 'WANGAME_ERR_PLAYER_GAME_VIP_REPEAT') {
                        onActivated();
                        return;
                    }
                }
                return;
            })
        }
    });

    useEffect(() => {
        if (!isActivated) {
            activate().finally();
        }
    }, [isActivated]);

    function renderContent() {
        if (activateLoading) {
            return <Spin>
                激活中
            </Spin>
        }

        return isActivated ? <>
            <VerifyResult
                status="success"
                title="恭喜您，已激活充值白名单"
                subTitle="可享充值100%返利"
            />
            <Row justify={"center"}>
                <Col>
                    <AtButton style={{
                        width: 200
                    }} type={"primary"} onClick={onCancel}
                    >关闭</AtButton>
                </Col>
            </Row>
        </> : <>
            <VerifyResult
                status={"warning"}
                title="激活失败"
            />
            <Row justify={"center"}>
                <Col>
                    <AtButton style={{
                        width: 200
                    }} type={"primary"} onClick={onCancel}
                    >关闭</AtButton>
                </Col>
            </Row>

        </>
    }

    return <ActivateLayout>
        {renderContent()}
    </ActivateLayout>
}
function VerifyModal(props: VerifyModalProps) {
    const {
        gameId,
        verified,
        open,
        onCancel,
        onFinish
    } = props;

    // console.log("verified:", verified)

    return <Modal
        title={"激活"}
        open={open}
        footer={false}
        onCancel={onCancel}
        destroyOnClose
    >
        {/*<Space direction={"vertical"}>*/}
        {verified ? <>
            <VerifiedActivate
                gameId={gameId}
                onCancel={onCancel}
                               // onCancel={onCancel}
            />
        </> : <>
            <VerifyMobile gameId={gameId} onFinish={() => {
                // console.log(`onFinish`)
                onFinish();
            }} />
        </>}
    </Modal>
}
export default VerifyModal;